/**
 * After a deploy, a tab opened earlier still asks for the old build's page files, which no longer
 * exist. Reloading picks up the new build. One reload at a time: if it fails again soon after
 * (offline, a bad deploy), the error screen shows instead of reloading for ever.
 */
const LAST_RELOAD_KEY = 'cd-stale-build-reload';
const RETRY_AFTER_MS = 60_000;

const STALE_BUILD_ERROR =
  /failed to fetch dynamically imported module|error loading dynamically imported module|importing a module script failed|unable to preload css/i;

export function isStaleBuildError(error: unknown): boolean {
  return error instanceof Error && STALE_BUILD_ERROR.test(error.message);
}

/** Reloads unless it just did; true when a reload is on its way. */
export function reloadOnce(
  reload: () => void = () => {
    window.location.reload();
  },
): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);
    if (Date.now() - last < RETRY_AFTER_MS) return false;
    window.sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  } catch {
    return false; // can't remember the attempt, so can't risk a reload loop
  }
  reload();
  return true;
}
